export default {
      id: "pause-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#pause-usage",
      toString: function () {
        return this.url;
      }
    }